import React,  {Fragment, useCallback  } from 'react';
import { Redirect } from 'react-router-dom';
import {
    TextInput,
    DateInput,
    FormDataConsumer,
    BooleanInput,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Edit,
    SimpleForm,
    useUpdate,
    useRedirect,
    useNotify
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import EditDetails from './EditDetails'

let uid = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CheckListEditActions =(basePath) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/recertificate?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}  label='List'/>
    </CardActions>
);


const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {  
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
};




const CheckListToolbar = props  => (
    <Toolbar {...props}>  
        <SaveButton
            label="save"    
            submitOnEnter={true}
            redirect={'/recertificate?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
        />

    </Toolbar>
);

const SaveWithNoteButton = props => {
    const [edit] = useUpdate('recertificate');
    const redirectTo = useRedirect();
    const notify = useNotify();
    const { basePath } = props;
    const handleSave = useCallback(
       
        (values, redirect) => {
            
            values && values.qa_sign && values.qa_sign > ' ' && values.qa_sign_date && values.qa_sign_date < ' '? 
            notify('QA sign date can not be empty', 'warning', {
                smart_count: 1,
            }) :
            edit(
                {
                    payload: { data: { ...values} },
                },
                {
                    onSuccess: ({ data: record }) => {
                        notify('Successfully updated!', 'info', {
                            smart_count: 1,
                        });
                        redirectTo(redirect, basePath, record.id, record);
                    },
                }
            );
        },
        [edit, notify, redirectTo, basePath]
    );
    // set onSave props instead of handleSubmitWithRedirect
    return <SaveButton {...props} onSave={handleSave} label={'Save with Note'}/>;
};


const Heading=({data})=>{
    //console.log(data)
    return (<h3>{data}</h3>)
}

const Textletters=({data})=>{
    return (<span>{data}</span>)
}

const GetKey=({ record }) => (
    console.log(record),
    uid = (record.uid)? record.uid:uid,
    (uid)? '': <Redirect to="/userslist" />
);

const RecertificateEdit =({ classes, ...props }) => (
    
<Edit 
    title='Recertificate | Edit' 
    {...props}  
    actions={<CheckListEditActions  />} 
    >
    <SimpleForm toolbar={<CheckListToolbar  />}>
    <GetKey props ={props}/>
    <table style={{width:"99%", fontSize: "12px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Annual Recertification Form
                                </td>
                            </tr>
                            <tr>
                                <td >
                                <FormDataConsumer>
                                {
                                    ({ formData, ...rest }) => <Heading  data={formData.name}/>  
                                }
                                </FormDataConsumer>
                                </td>
                            </tr>
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Employee Name:</td>
                <td  colSpan="3"><TextInput source="emp_name" label="" /></td>
            </tr>
            <tr>
                <td>Employee Titile:</td>
                <td  colSpan="3"><TextInput source="emp_title" label="" /></td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"60%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date of Reading</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"10%", textAlign: "center"}}>Employee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date</th>
                            </tr>
                            <FormDataConsumer>
                            {
                                ({ formData, ...rest }) =>
                                <EditDetails  data={formData} />
                            }
                            </FormDataConsumer>
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <FormDataConsumer>
            {
            ({ formData, ...rest }) =>
                (formData.isphy_sub )?(
                    <Fragment>
                    <tr>
                        <td  colSpan="4">
                        <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <td>
                                    <table style={{ width:"100%"}}>
                                    <tbody>
                                        <tr>
                                            <td colSpan="4"><b>For Physician Substitute ONLY</b></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2">Physical Examination performed in presence of CMD on Date:</td>
                                            <td colSpan="2"><DateInput source="cmd_date" label="" locales="en-us" /></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="4">
                                            <u>CMD Comments:</u>
                                            <TextInput source="cmd_comments" label="" multiline fullWidth />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Center Medical Director Signature:</td>
                                            <td><TextInput source="cmd_sign" label=""  /></td>
                                            <td>&nbsp;Date:</td>
                                            <td><DateInput source="cmd_sign_date" label="" locales="en-us" /></td>
                                        </tr>
                                    </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                        </td>
                    </tr>
                    <tr><td  colSpan="4">&nbsp;</td></tr>
                </Fragment>): null
            }
            </FormDataConsumer>
            <tr>
                <td  colSpan="2">
                <FormDataConsumer>
                {
                    ({ formData, ...rest }) =><Textletters data={formData.exam_desc} />
                }
                </FormDataConsumer>
                    &nbsp;&nbsp;&nbsp;<b>Pass/Fail:</b>
                </td>
                <td colSpan="2"><BooleanInput source="ispass" label="" /></td>
            </tr>
            <tr>
                <td colSpan="4">
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td>Employee Name</td><td><TextInput source="emp_name" label="" /></td>
                                <td>Signature</td><td><TextInput source="emp_sign" label="" /></td>
                                <td>Date</td><td><DateInput source='emp_sign_date' label="" locales="en-us"/></td>
                            </tr>
                            <tr>
                                <td>Management/QA review</td><td><TextInput source="qa_review" label="" /></td>
                                <td>Signature</td><td><TextInput source="qa_sign" label="" /></td>
                                <td>Date</td><td><DateInput source='qa_sign_date'    label="" locales="en-us"  /></td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            </tbody>
        </table>
    </SimpleForm>
</Edit>
);

export default withStyles(editStyles)(RecertificateEdit);